import { takeEvery, put } from 'redux-saga/effects'
import { MAKEUP_LIST, SET_MAKEUP_LIST, SET_TRANSPORT_LIST, TRANSPORT_LIST } from '../constant';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

function* getMakeups() {
    let data = yield fetch(baseUrl + "/api/v1/makeup/list");
    data = yield data.json();
    data = data.data;
    console.log("action is called", data)
    yield put({type: SET_MAKEUP_LIST, data})
}

function* makeupSaga() {
    yield takeEvery(MAKEUP_LIST, getMakeups)
}

export default makeupSaga;